import axios from 'axios';
import { messageNotification } from '@shared/services/gf.notification.service';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member

export default {
  createTeam(data) {
    return axios
      .post(`/api/admin/team/create`, data, {
        formName: FORM_NAME_ENUMS.TEAM_CREATE_FORM
      })
      .then((res) => {
        console.log(res);
        return res?.data;
      })
      .catch((err) => {
        messageNotification('danger', {
          message: 'Проверьте корректность заполнения формы!',
          hasTimeline: false
        });
        throw err;
      });
  },
  createCompany(data) {
    return axios
      .post(`/api/admin/company/create`, data, {
        formName: FORM_NAME_ENUMS.COMPANY_CREATE_FORM
      })
      .then((res) => {
        return res?.data;
      })
      .catch((err) => {
        messageNotification('danger', {
          message: 'Проверьте корректность заполнения формы!',
          hasTimeline: false
        });
        throw err;
      });
  },
  getAllowedTeamOwners(params) {
    return axios
      .get(`/api/admin/team/create/allowed-team-owners`, { params })
      .then((res) => res.data);
  }
};
